export const TV_COLORS = {
  red: '#E53935',
  blue: '#1E88E5',
  yellow: '#FFD600',
  orange: '#FF9800',
  violet: '#8E24AA',
  cyan: '#26C6DA',
  black: '#121212',
  gold: '#F9C846',
  white: '#FFFFFF',
}

export const tvGradientBackground = {
  backgroundImage:
    'radial-gradient(circle at top, rgba(255,214,0,0.35) 0%, transparent 40%), linear-gradient(135deg, #1E1B4B 0%, #24124D 45%, #350b4d 75%, #120C1B 100%)',
  border: '1px solid rgba(255,255,255,0.1)',
  boxShadow: '0 0 30px rgba(30,136,229,0.35)',
  position: 'relative' as const,
  overflow: 'hidden' as const,
}

export const neonText = (color: string) => ({
  textShadow: `0 0 4px ${color}, 0 0 12px ${color}, 0 0 24px ${color}`,
})

export const glowBox = (color: string) => ({
  boxShadow: `0 0 10px ${color}, 0 0 25px ${color}`,
})

export const goldFrameStyles = {
  border: '4px solid transparent',
  borderImage: 'linear-gradient(90deg,#F9C846,#FFEA8A,#F9C846) 1',
  boxShadow: '0 12px 20px rgba(0,0,0,0.35), inset 0 0 25px rgba(249,200,70,0.4)',
  background: 'radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, rgba(0,0,0,0.65) 80%)',
}

type BuzzerOverrides = {
  base?: string
  dark?: string
}

export const buzzerButton = (variant: 'higher' | 'lower', overrides: BuzzerOverrides = {}) => {
  const defaultBase = variant === 'higher' ? '#00C853' : '#E53935'
  const defaultDark = variant === 'higher' ? '#009624' : '#8E1111'
  const baseColor = overrides.base ?? defaultBase
  const dark = overrides.dark ?? defaultDark
  return {
    fontFamily: 'Bebas Neue, sans-serif',
    letterSpacing: 1,
    fontSize: 20,
    color: '#fff',
    background: `radial-gradient(circle at 30% 20%, rgba(255,255,255,0.35), transparent 40%), linear-gradient(180deg, ${baseColor} 0%, ${dark} 90%)`,
    borderRadius: 3,
    paddingY: 1,
    paddingX: 2,
    border: '3px solid rgba(255,255,255,0.4)',
    boxShadow: `0 12px 0 ${dark}, 0 0 25px rgba(255,255,255,0.3)`,
    transform: 'translateY(0)',
    transition: 'transform 120ms ease, box-shadow 120ms ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: `0 14px 0 ${dark}, 0 0 35px rgba(255,255,255,0.5)`,
    },
    '&:active': {
      transform: 'translateY(4px)',
      boxShadow: `0 6px 0 ${dark}`,
    },
  }
}

export const priceBillboardStyles = {
  background: 'linear-gradient(120deg, rgba(255,214,0,0.15), rgba(255,214,0,0.02))',
  border: '3px solid rgba(255,214,0,0.6)',
  borderRadius: 2,
  padding: '16px 20px',
  color: TV_COLORS.yellow,
  fontFamily: 'Orbitron, Bebas Neue, sans-serif',
  textTransform: 'uppercase' as const,
  letterSpacing: 1,
  ...glowBox('rgba(255,214,0,0.55)'),
}
